import { computed, onMounted, reactive, ref } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';

/** Estado de filtros/ordenação do board (busca, responsável, caixa, só meus). */
export function useKanbanFilters() {
  const store = useStore();

  const agents = useMapGetter('agents/getVerifiedAgents');
  const inboxes = useMapGetter('inboxes/getInboxes');
  const currentUserId = useMapGetter('getCurrentUserID');

  const filters = reactive({
    search: '',
    agentId: null, // Number | 'unassigned' | null
    inboxId: null, // Number | null
    onlyMine: false,
  });

  const sortOrder = ref('none'); // 'none' | 'desc' | 'asc'

  onMounted(() => {
    store.dispatch('agents/get');
    store.dispatch('inboxes/get');
    store.dispatch('labels/get');
  });

  const hasActiveFilters = computed(
    () =>
      Boolean(filters.search) ||
      filters.agentId !== null ||
      filters.inboxId !== null ||
      filters.onlyMine
  );

  const resetFilters = () => {
    filters.search = '';
    filters.agentId = null;
    filters.inboxId = null;
    filters.onlyMine = false;
  };

  const toggleSort = () => {
    if (sortOrder.value === 'none') sortOrder.value = 'desc';
    else if (sortOrder.value === 'desc') sortOrder.value = 'asc';
    else sortOrder.value = 'none';
  };

  return {
    agents,
    inboxes,
    currentUserId,
    filters,
    sortOrder,
    hasActiveFilters,
    resetFilters,
    toggleSort,
  };
}
